import { Injectable } from '@angular/core';
import { LoopBackFilter } from './lbsdk';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Constants } from '../constants';
import { PacienteApi } from './lbsdk/services/custom/Paciente';
import { EstadoApi } from './lbsdk';
import { MedicionApi } from './lbsdk';
@Injectable()
export class PatientService {
  // este es el lugar para meter lógica de negocios si la hubiera

  constructor(
    private patientApi: MedicionApi, private stateApi: EstadoApi, private http: HttpClient, private pacienteApi: PacienteApi
  ) { }

  countSql(filtro) {

    return this.http.get(Constants.hostApiNode + '/api/Pacientes/count', {
      params: {
        where: JSON.stringify(filtro)
      }
    })
  }



  findSqlStore(filtro) {
    console.log(filtro)
   
    // let params = new HttpParams();
    //params = params.append('filter', JSON.stringify(params));
   // return this.http.post(Constants.hostApiNode + '/api/Pacientes/GetPacientesSql', filtro)
   return this.http.post(Constants.hostApiNode + '/api/Medicions/GetMedicionesSql', filtro)
  }
  findSql(filtro) {
    console.log(filtro)
    // let params = new HttpParams();
    //params = params.append('filter', JSON.stringify(params));
   // return this.http.get(Constants.hostApiNode + '/api/Pacientes', {
    return this.http.get(Constants.hostApiNode + '/api/Medicions', {
      params: {
        filter: JSON.stringify(filtro)
      }
    })
  }

  findMedicionSql(filtro) {
    console.log(filtro)
    // let params = new HttpParams();
    //params = params.append('filter', JSON.stringify(params));
    return this.http.get(Constants.hostApiNode + '/api/Medicions',  {
      params: {
        filter: JSON.stringify(filtro)
      }
    })
  }
  

  find(filter) {//: LoopBackFilter = {}) {
    //  alert(filter);
    console.log(filter)
    return this.patientApi.find(filter)
  }
  findById(id, filtro) {
    return this.patientApi.findById(id, filtro)
  }

  update(data, id) {
    return this.patientApi.patchAttributes(id, { result: data })
    // return this.patientApi.updateAll({ company: "Goldcorp" },{company:"German"})      

  }

  updateState(data, id): Observable<any> {
    return this.patientApi.patchAttributes(id, { state: data })
    // return this.patientApi.updateAll({ company: "Goldcorp" },{company:"German"})      

  }
  updateStateSql(data, id): Observable<any> {
    
    return this.pacienteApi.patchAttributes(id, { state: data })

  }


  updateNros(nroSobre, nroArreglo, id): Observable<any> {
    return this.patientApi.patchAttributes(id, { nroSobre: nroSobre, nroArreglo: nroArreglo })
    // return this.patientApi.updateAll({ company: "Goldcorp" },{company:"German"})      

  }

  updateNrosSql(nroSobre, nroArreglo, id): Observable<any> {
    return this.pacienteApi.patchAttributes(id, { nroSobre: nroSobre, nroArreglo: nroArreglo })
    // return this.patientApi.updateAll({ company: "Goldcorp" },{company:"German"})      

  }

  //count(filter: LoopBackFilter = {}) {
  count(filter) {
    return this.patientApi.count(filter)
    // return this.patientApi.updateAll({ company: "Goldcorp" },{company:"German"})      

  }

  countFind(filter) {
    return this.patientApi.find(filter).count();
    // return this.patientApi.updateAll({ company: "Goldcorp" },{company:"German"})      

  }

  getState(filter: LoopBackFilter = {}) {
    return this.stateApi.find(filter)
  }
}



// WEBPACK FOOTER //
// ./src/services/patient.service.ts